"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotifyMe = void 0;
const getNotifyMe = async (supabase) => {
    const { data, error } = await supabase
        .from("notify_me")
        .select(`*,    
    course:courses!course_id(
        *,
        region:regions!region_id(
          *, country:countries!country_id(*)
        )),
    agent:agent_accounts!agent_id(*, agent_config:agent_configurations!agent_config_id(*))
    `)
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getNotifyMe = getNotifyMe;
